.dealsPage {
  margin: 0 5rem;
}

.welcomeUser {
  padding: 2rem 0 1.2rem 0;
}

.deals {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: 'deal deal';
  padding: 0 0 2rem 0;
  gap: 1rem;
}

.deal {
  grid-area: deal;
}

@media only screen and (max-width: 550px) {
  .deals {
    grid-template-columns: 1fr;
    grid-template-areas: 'deal';
  }
}

@media only screen and (max-width: 1024px) {
  .dealsPage {
    margin: 0 1rem;
  }
}
